import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, of } from 'rxjs';
import { delay, finalize, takeUntil } from 'rxjs/operators';
import { AccountService } from 'src/app/shared/services/account.service';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
    selector: 'app-view-log-search',
    templateUrl: './view-log-search.component.html',
    styleUrls: ['./view-log-search.component.scss'],
    standalone: false
})
export class ViewLogSearchComponent implements OnInit, OnDestroy {
  public searchForm: FormGroup;
  loading: boolean = false;
  private riaId: number;
  private destroy$ = new Subject<void>();

  constructor(private accountService: AccountService, private fb: FormBuilder, private dataService: DataService) { }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required]
    });

    this.dataService.currentRiaId$
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        value => this.riaId = value
      );
  }

  ngOnDestroy(): void {
    this.onReset();
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSearch(): void {
    if (this.searchForm.valid) {
      this.loading = true;

      // Emit the search criteria
      this.accountService.searchLogExecutedSubject.next({
        riaId: this.riaId,
        fromDate: this.searchForm.value.fromDate,
        toDate: this.searchForm.value.toDate,
      });

      // Create an observable to manage the delay
      of(null).pipe(
        delay(1000),  // Delay for 1 seconds
        finalize(() => this.loading = false)  // Set loading to false after the delay
      ).subscribe();
    }
  }

  onReset(): void {
    this.searchForm.reset();
    this.accountService.searchLogExecutedSubject.next({
      riaId: null,
      fromDate: this.searchForm.value.fromDate,
      toDate: this.searchForm.value.toDate,
    });
  }
}
